import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ListRegular from './list-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ListRegular {...validProps} />;
}
SvgComponent.iconName = 'listRegular';

export const ListRegularIcon = svgIconWrapper(SvgComponent);
